function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FF7272",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 8L4 8 36 8M32 8v28c0 2.21-1.79 4-4 4H8c-2.21 0-4-1.79-4-4V8m6 0V4c0-2.21 1.79-4 4-4h8c2.21 0 4 1.79 4 4v4M14 18v12M22 18v12",
  transform: "translate(1 1)"
}));

var SvgIcoTrash = function SvgIcoTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-trash.3e41fbb0.svg";
export { ForwardRef as ReactComponent };